// src/pages/auth/ForgotPasswordPage.tsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSendResetEmail } from '../../features/auth/api';
import loginBg from '../../assets/login-bg.jpeg';
import logoImage from '../../assets/bg_transparent.png';
import './LoginPage.scss';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const sendReset = useSendResetEmail();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const target = email.trim().toLowerCase();

    if (!target) {
      toast.warn('Enter your email.');
      return;
    }

    sendReset.mutate(target, {
      onSuccess: () => {
        toast.success('If an account exists, a reset link was sent.');
      },
      onError: () => {
        toast.error('Could not send reset email.');
      },
    });
  };

  return (
    <div className="login-page" style={{ backgroundImage: `url(${loginBg})` }}>
      <div className="login-card">
        <div className="logo">
          <img src={logoImage} alt="BULK MATERIAL PRO" className="logo-image" />
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div style={{ textAlign: 'center', marginBottom: 18 }}>
            <h2 style={{ margin: 0 }}>Reset Password</h2>
            <p className="muted" style={{ marginTop: 8 }}>
              Enter your email and we’ll send you a secure reset link.
            </p>
          </div>

          <div className="form-group">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Email Address"
            />
          </div>

          <div className="form-actions">
            <Link to="/login" className="forgot-password">
              Back to login
            </Link>

            <button type="submit" className="login-button" disabled={sendReset.isPending}>
              {sendReset.isPending ? 'Sending…' : 'SEND RESET LINK'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
